import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { API, TopicDTO, UserDTO } from '../../../services/api/api';
import { UtilService } from '../../../services/util.service';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { DiscussionService } from '../../../services/discussion.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-discussion-main-post',
  templateUrl: './sb-comp-discussion-main-post.component.html',
  styleUrls: ['./sb-comp-discussion-main-post.component.scss'],
  standalone: false,
})
export class SbCompDiscussionMainPostComponent implements OnInit {
  @Input() mainPost: TopicDTO;
  @Input() currentUser: UserDTO;

  @Output() editMainPost: EventEmitter<boolean>;
  @Output() deleteMainPost: EventEmitter<number>;

  isSelf: boolean;
  editClicked: boolean;
  reply: string;

  constructor(
    public api: API,
    public util: UtilService,
    public modalService: ModalService,
    public translate: TranslateService,
    public discussionService: DiscussionService,
    public destroyRef: DestroyRef
  ) {
    this.isSelf = false;
    this.editClicked = false;
    this.editMainPost = new EventEmitter<boolean>();
    this.deleteMainPost = new EventEmitter<number>();
    this.reply = '';
  }

  ngOnInit(): void {
    if (this.currentUser && this.mainPost) {
      this.isSelf = this.mainPost.createdBy.name === this.currentUser.name;
    }
  }

  setDoneTopic($event: MouseEvent) {
    if ($event) {
      $event.stopPropagation();
    }
    if (!this.editClicked) {
      this.api
        .shared_Discussion_setDone(this.mainPost.id)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe(() => {});
    }
  }

  editTopic($event: MouseEvent) {
    if ($event) {
      $event.stopPropagation();
    }
    if (!this.editClicked) {
      this.reply = this.mainPost.text;
      this.editClicked = true;
    } else {
      this.mainPost.text = this.reply;
      this.api
        .shared_Discussion_editTopic(this.mainPost)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe(() => {
          this.editMainPost.emit(true);
        });
      this.reply = '';
      this.editClicked = false;
    }
  }

  deleteTopic($event: MouseEvent) {
    if ($event) {
      $event.stopPropagation();
    }
    if (this.editClicked) {
      this.editClicked = false;
      this.reply = '';
    } else {
      this.modalService
        .confirm({
          title: this.translate.instant('lang.globals.deleteTopic'),
          message: this.translate.instant('lang.globals.deleteTopicMessage', { value: this.mainPost.title }),
          yes: this.translate.instant('lang.globals.yes'),
          no: this.translate.instant('lang.globals.no'),
        })
        .then((result: boolean) => {
          if (result) {
            this.api
              .shared_Discussion_deleteTopic(this.mainPost.id)
              .pipe(takeUntilDestroyed(this.destroyRef), take(1))
              .subscribe(() => {
                this.deleteMainPost.emit(this.mainPost.id);
              });
          }
          this.discussionService.modalOpenClick();
        })
        .catch(() => {});
    }
  }
}
